import { Component, OnInit, OnDestroy, ViewChild } from "@angular/core";
import { MatTableDataSource } from "@angular/material/table";
import { MatSort } from "@angular/material/sort";
import { MatPaginator } from "@angular/material/paginator";
import { Subscription, interval } from "rxjs";
import { ReportsService } from "../services/reports.service";
import { ReportModel } from "../shared/report.model";
import { DashboardService } from "../services/dashboard.service";
import { MothlyReportModel } from "../shared/monthlyreport.model";
import { ProjectService } from "../services/project.service";
import { switchMap, takeWhile, finalize } from 'rxjs/operators';
import { Router } from "@angular/router";
import { environment } from "../../environments/environment";


export interface ProjectListModel {
  project_id: number;
  project_name: string;
}

@Component({
  selector: "app-reports",
  templateUrl: "./reports.component.html",
  styleUrls: ["./reports.component.css"],
})
export class ReportsComponent implements OnInit, OnDestroy {
  allReportsSubs$: Subscription;
  allReportsOnDownloadSubs$: Subscription;
  masterReport$: Subscription;
  allProjectReportsList = [];
  reportsOnDownload = [];
  masterFileLink: string | null = null;
  showSelects = true;
  isMasterGenerating = false;
  isMasterDownloading = false;
  masterReportError = "";
  private masterStatusSub: Subscription;
  private masterSubmitSub: Subscription;
  displayedColumns: string[] = ["name", "datetimestamp", "id", "file_link"];
  projectColumns: string[] = ["name", "date", "type", "pdf",];
  criticalColumns: string[] = ["name", "date", "pdf",];

  //  for dropdown list  //

  dashboardDataSubs: Subscription;
  projectsListSubs: Subscription;
  calaListSubs: Subscription;
  roListSubs: Subscription;
  collectorListSubs: Subscription;
  commissionerListSubs: Subscription;

  dashboardData: any;
  projectsList$: ProjectListModel[];
  calaList$ = [];

  roList = [];
  collectorList$ = [];
  commissionerList$ = [];
  monthlyProjectReport: Subscription;
  monthlyCalaReport: Subscription;
  monthlycollectorreport: Subscription;
  monthlycommissionerReport: Subscription;
  monthlycriticalReport: Subscription;
  RoName;
  ProjectName;
  calaName;
  collectorName;
  commissionerName;
  criticaldata = [];
  agencyId = "total"
  agencyArray: any;
  disignation;

  selectedAgency: any = null;
  selectedProject: any = null;
  selectedCala: any = null;
  selectedCollector: any = null;
  selectedCommissioner: any = null;
  selectedRoCritical: any = null;
  selectedRoGenerate: any = null;

  showProjectTable = false;
  showCalaTable = false;
  showCollectorTable = false;
  showCommissionerTable = false;
  showCriticalTable = false;
  //  Ends of dropdown list 

  public dataSource = new MatTableDataSource<any>();
  public projectdataSource = new MatTableDataSource<any>();
  public caladataSource = new MatTableDataSource<any>();
  public collectordataSource = new MatTableDataSource<any>();
  public commissionerdataSource = new MatTableDataSource<any>();
  public criticaldataSource = new MatTableDataSource<any>();

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  constructor(private reportsService: ReportsService,
    private dashboardService: DashboardService,
    private projectService: ProjectService,
    private router: Router) { }

  ngOnInit(): void {

    this.disignation = localStorage.getItem('designation')

    //3. Agencies
    this.projectService.getAgencies().subscribe((res) => {
      console.log(res, "aggenciesks")
      this.agencyArray = res;
    });

    //  For getting project,cala,collector and commisioner list //


    this.projectsListSubs = this.dashboardService
      .getAllProjects(this.agencyId)
      .subscribe((res) => {
        this.projectsList$ = res;
        this.projectsList$ = this.projectsList$.sort(function (a, b) {
          if (a.project_name.toLowerCase() < b.project_name.toLowerCase()) { return -1; }
          if (a.project_name.toLowerCase() > b.project_name.toLowerCase()) { return 1; }
          return 0;
        })
      });

    this.dashboardDataSubs = this.dashboardService
      .getDashboardData(this.agencyId)
      .subscribe((res) => {
        this.dashboardData = res;
        console.log(res);
      });

    this.calaListSubs = this.dashboardService
      .getAllCalaList(this.agencyId)
      .subscribe((res) => {
        this.calaList$ = [...res];
        this.calaList$ = this.calaList$.sort(function (a, b) {
          if (a.name.toLowerCase() < b.name.toLowerCase()) { return -1; }
          if (a.name.toLowerCase() > b.name.toLowerCase()) { return 1; }
          return 0;
        })
        // console.log(res);
      });

    this.roListSubs = this.dashboardService.getROList(this.agencyId).subscribe((res) => {
      this.roList = [...res];
    });

    this.collectorListSubs = this.dashboardService
      .getDistrictCollectorList(this.agencyId)
      .subscribe((res) => {
        this.collectorList$ = [...res];
        this.collectorList$ = this.collectorList$.sort(function (a, b) {
          if (a.name.toLowerCase() < b.name.toLowerCase()) { return -1; }
          if (a.name.toLowerCase() > b.name.toLowerCase()) { return 1; }
          return 0;
        })
      });

    this.commissionerListSubs = this.dashboardService
      .getCommissionerList(this.agencyId)
      .subscribe((res) => {
        this.commissionerList$ = [...res];
        this.commissionerList$ = this.commissionerList$.sort(function (a, b) {
          if (a.name.toLowerCase() < b.name.toLowerCase()) { return -1; }
          if (a.name.toLowerCase() > b.name.toLowerCase()) { return 1; }
          return 0;
        })
      });

    this.allReportsSubs$ = this.reportsService
      .getAllProjectsList()
      .subscribe((res) => {
        console.log(res);
        this.dataSource.data = res.reverse() as ReportModel[];
      });

    this.reportsService.getReportsOnDownload().subscribe((res) => {
      this.reportsOnDownload = [...res];
    });


    this.roListSubs = this.dashboardService.getROList(this.agencyId).subscribe((res) => {
      this.roList = [...res];
    });


  }
  private hideTable(id: string): void {
    if (id === 'project_report') this.showProjectTable = false;
    if (id === 'cala_report') this.showCalaTable = false;
    if (id === 'collector_report') this.showCollectorTable = false;
    if (id === 'commissioner_report') this.showCommissionerTable = false;
    if (id === 'critical_report') this.showCriticalTable = false;
  }

  // getAgencyId(id){

  //   this.projectsListSubs = this.dashboardService
  //       .getAllProjects(id)
  //       .subscribe((res) => {
  //         this.projectsList$ = res;
  //         this.projectsList$ = this.projectsList$.sort(function (a, b) {
  //           if (a.project_name.toLowerCase() < b.project_name.toLowerCase()) { return -1; }
  //           if (a.project_name.toLowerCase() > b.project_name.toLowerCase()) { return 1; }
  //           return 0;
  //         })
  //       });

  //     this.dashboardDataSubs = this.dashboardService
  //       .getDashboardData(id)
  //       .subscribe((res) => {
  //         this.dashboardData = res;
  //         console.log(res);
  //       });

  //     this.calaListSubs = this.dashboardService
  //       .getAllCalaList(id)
  //       .subscribe((res) => {
  //         this.calaList$ = [...res];
  //         this.calaList$ = this.calaList$.sort(function (a, b) {
  //           if (a.name.toLowerCase() < b.name.toLowerCase()) { return -1; }
  //           if (a.name.toLowerCase() > b.name.toLowerCase()) { return 1; }
  //           return 0;
  //         })
  //         // console.log(res);
  //       });

  //     this.roListSubs = this.dashboardService.getROList(id).subscribe((res) => {
  //       this.roList = [...res];
  //     });

  //     this.collectorListSubs = this.dashboardService
  //       .getDistrictCollectorList(id)
  //       .subscribe((res) => {
  //         this.collectorList$ = [...res];
  //         this.collectorList$ = this.collectorList$.sort(function (a, b) {
  //           if (a.name.toLowerCase() < b.name.toLowerCase()) { return -1; }
  //           if (a.name.toLowerCase() > b.name.toLowerCase()) { return 1; }
  //           return 0;
  //         })
  //       });

  //     this.commissionerListSubs = this.dashboardService
  //       .getCommissionerList(id)
  //       .subscribe((res) => {
  //         this.commissionerList$ = [...res];
  //         this.commissionerList$ = this.commissionerList$.sort(function (a, b) {
  //           if (a.name.toLowerCase() < b.name.toLowerCase()) { return -1; }
  //           if (a.name.toLowerCase() > b.name.toLowerCase()) { return 1; }
  //           return 0;
  //         })
  //       });




  //   this.roListSubs = this.dashboardService.getROList(id).subscribe((res) => {
  //     this.roList = [...res];
  //   });
  // }
  getAgencyId(id: any): void {
    this.agencyId = id;

    this.selectedProject = null;
    this.selectedCala = null;
    this.selectedCollector = null;
    this.selectedCommissioner = null;
    this.selectedRoCritical = null;
    this.selectedRoGenerate = null;

    this.ProjectName = null;
    this.calaName = null;
    this.collectorName = null;
    this.commissionerName = null;
    this.RoName = null;

    this.hideTable('project_report');
    this.hideTable('cala_report');
    this.hideTable('collector_report');
    this.hideTable('commissioner_report');
    this.hideTable('critical_report');

    this.projectdataSource.data = [];
    this.caladataSource.data = [];
    this.collectordataSource.data = [];
    this.commissionerdataSource.data = [];
    this.criticaldataSource.data = [];

    this.showProjectTable = false;
    this.showCalaTable = false;
    this.showCollectorTable = false;
    this.showCommissionerTable = false;
    this.showCriticalTable = false;

    this.projectsListSubs = this.dashboardService
      .getAllProjects(id)
      .subscribe((res) => {
        this.projectsList$ = (res || []).sort((a, b) =>
          a.project_name.toLowerCase().localeCompare(b.project_name.toLowerCase())
        );
      });

    this.dashboardDataSubs = this.dashboardService
      .getDashboardData(id)
      .subscribe((res) => { this.dashboardData = res; });

    this.calaListSubs = this.dashboardService
      .getAllCalaList(id)
      .subscribe((res) => {
        this.calaList$ = [...res].sort((a, b) =>
          a.name.toLowerCase().localeCompare(b.name.toLowerCase())
        );
      });

    this.roListSubs = this.dashboardService
      .getROList(id)
      .subscribe((res) => { this.roList = [...res]; });

    this.collectorListSubs = this.dashboardService
      .getDistrictCollectorList(id)
      .subscribe((res) => {
        this.collectorList$ = [...res].sort((a, b) =>
          a.name.toLowerCase().localeCompare(b.name.toLowerCase())
        );
      });

    this.commissionerListSubs = this.dashboardService
      .getCommissionerList(id)
      .subscribe((res) => {
        this.commissionerList$ = [...res].sort((a, b) =>
          a.name.toLowerCase().localeCompare(b.name.toLowerCase())
        );
      });
    // Force all ng-selects to re-render with cleared state
    this.showSelects = false;
    setTimeout(() => this.showSelects = true, 0);
  }


  public doFilter = (value: string) => {
    this.dataSource.filter = value.trim().toLocaleLowerCase();
  };

  masterReport() {
    if (this.isMasterGenerating) {
      return;
    }

    this.isMasterGenerating = true;
    this.masterFileLink = null;
    this.masterReportError = "";

    this.masterSubmitSub = this.reportsService.submitMasterReport().subscribe(
      (submitRes) => {
        console.log('submit master report res', submitRes);
        const taskId = submitRes.task_id;

        this.masterStatusSub = interval(3000)
          .pipe(
            switchMap(() => this.reportsService.getMasterReportStatus(taskId)),
            takeWhile((statusRes) => statusRes.status !== 'SUCCESS' && statusRes.status !== 'FAILURE', true),
            finalize(() => {
              this.isMasterGenerating = false;
            })
          )
          .subscribe(
            (statusRes) => {
              console.log('status res', statusRes);

              if (statusRes.status === 'SUCCESS') {
                if (statusRes.result && statusRes.result.report_url) {
                  this.masterFileLink = statusRes.result.report_url;
                } else {
                  this.masterReportError = 'Report generated, but no download file was returned.';
                }
              } else if (statusRes.status === 'FAILURE') {
                this.masterReportError = 'Master report generation failed. Please try again.';
                console.error('Master report generation failed');
              }
            },
            (err) => {
              this.masterReportError = 'Unable to check report status. Please try again.';
              console.error('Error while polling master report status', err);
            }
          );
      },
      (err) => {
        this.isMasterGenerating = false;
        this.masterReportError = 'Unable to start report generation. Please try again.';
        console.error('Error submitting master report', err);
      }
    );
  }

  downloadMasterReport() {
    if (!this.masterFileLink || this.isMasterDownloading) {
      return;
    }

    const reportUrl = this.masterFileLink;
    this.isMasterDownloading = true;
    this.masterReportError = "";

    this.reportsService.downloadGeneratedReport(reportUrl).subscribe(
      (file) => {
        this.saveFile(file, reportUrl, "master-report.csv");
        this.isMasterDownloading = false;
      },
      (err) => {
        this.isMasterDownloading = false;
        this.masterReportError = "Unable to download the generated report. Please try again.";
        console.error("Error downloading master report", err);
      }
    );
  }

  private getAbsoluteReportUrl(reportUrl: string): string | null {
    const url = (reportUrl || "").trim();

    if (!url) {
      return null;
    }

    if (/^https?:\/\//i.test(url)) {
      return url;
    }

    if (/^[a-z][a-z\d+.-]*:/i.test(url)) {
      return null;
    }

    const configuredBaseUrl = (environment.baseUrl || "").replace(/^\/+|\/+$/g, "");
    const absoluteBaseUrl = /^https?:\/\//i.test(environment.baseUrl)
      ? environment.baseUrl
      : `https://${configuredBaseUrl}`;
    const baseProtocol = absoluteBaseUrl.toLowerCase().startsWith("http://")
      ? "http:"
      : "https:";

    if (url.startsWith("//")) {
      return `${baseProtocol}${url}`;
    }

    if (/^[\w.-]+\.[a-z]{2,}(?::\d+)?(?:\/|$)/i.test(url)) {
      return `${baseProtocol}//${url}`;
    }

    try {
      return new URL(url, `${absoluteBaseUrl.replace(/\/+$/, "")}/`).toString();
    } catch {
      return null;
    }
  }

  private prepareMonthlyReports(reports: MothlyReportModel[]): MothlyReportModel[] {
    return (Array.isArray(reports) ? reports : []).map((report) => ({
      ...report,
      pdf: this.getAbsoluteReportUrl(report && report.pdf),
    }));
  }

  private saveFile(file: Blob, sourceUrl: string, fallbackName: string): void {
    const objectUrl = URL.createObjectURL(file);
    const anchor = document.createElement("a");
    anchor.href = objectUrl;
    anchor.download = this.getFileName(sourceUrl, fallbackName);
    document.body.appendChild(anchor);
    anchor.click();
    anchor.remove();
    window.setTimeout(() => URL.revokeObjectURL(objectUrl), 60000);
  }

  private getFileName(sourceUrl: string, fallbackName: string): string {
    const urlWithoutQuery = (sourceUrl || "").split(/[?#]/)[0];
    const encodedName = urlWithoutQuery.split("/").pop();

    if (!encodedName) {
      return fallbackName;
    }

    try {
      return decodeURIComponent(encodedName);
    } catch {
      return encodedName;
    }
  }

  projectDashboard(id) {
    this.hideTable('project_report');
    this.projectdataSource.data = [];
    if (!id) return;

    const project = this.projectsList$.find((p) => p.project_id === parseInt(id));
    if (!project) return;
    this.ProjectName = project.project_name;

    this.monthlyProjectReport = this.reportsService
      .getProjectMonthlyReport(id)
      .subscribe(res => {
        this.projectdataSource.data = this.prepareMonthlyReports(res);
        this.showProjectTable = true;
      });
  }

  calaDashboard(id) {
    this.hideTable('cala_report');
    this.caladataSource.data = [];
    if (!id) return;

    const cala = this.calaList$.find((p) => p.id === parseInt(id));
    if (!cala) return;
    this.calaName = cala.name;

    this.monthlyCalaReport = this.reportsService
      .getCalaMonthlyReport(id)
      .subscribe(res => {
        this.caladataSource.data = this.prepareMonthlyReports(res);
        this.showCalaTable = true;
      });
  }

  collectorDashboard(id) {
    this.hideTable('collector_report');
    this.collectordataSource.data = [];
    if (!id) return;

    const collector = this.collectorList$.find((p) => p.id === parseInt(id));
    if (!collector) return;
    this.collectorName = collector.name;

    this.monthlycollectorreport = this.reportsService
      .getCollectorMonthlyReport(id)
      .subscribe(res => {
        this.collectordataSource.data = this.prepareMonthlyReports(res);
        this.showCollectorTable = true;
      });
  }

  commissionerDashboard(id) {
    // Hide table first (handles re-selection of same value)
    this.hideTable('commissioner_report');
    this.commissionerdataSource.data = [];

    if (!id) return;

    const comm = this.commissionerList$.find((p) => p.id === parseInt(id));
    if (!comm) return;
    this.commissionerName = comm.name;

    this.monthlycommissionerReport = this.reportsService
      .getCommissionerMonthlyReport(id)
      .subscribe(res => {
        this.commissionerdataSource.data = this.prepareMonthlyReports(res);
        this.showCommissionerTable = true;
      });
  }

  criticalReports(id) {
    // Hide table first (handles re-selection of same value)
    this.hideTable('critical_report');
    this.criticaldataSource.data = [];

    if (!id) return;

    const ro = this.roList.find((p) => p.id === parseInt(id));
    if (!ro) return;
    this.RoName = ro.name;

    this.monthlycriticalReport = this.reportsService
      .getCriticalMonthlyReport(id)
      .subscribe(res => {
        this.criticaldata = this.prepareMonthlyReports(res).reverse();
        this.criticaldataSource.data = this.criticaldata as MothlyReportModel[];
        this.showCriticalTable = true;
      });
  }
  criticalReportsgenerate(id) {
    const [ro] = this.roList.filter((p) => p.id === parseInt(id));
    this.router.navigate([
      "critical-analysis-report",
      id,
      "projectList",
    ]);
  }



  ngAfterViewInit(): void {
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
  }

  ngOnDestroy() {
    this.allReportsSubs$.unsubscribe();
    // this.masterReport$.unsubscribe();

    this.dashboardDataSubs.unsubscribe();
    this.projectsListSubs.unsubscribe();
    this.calaListSubs.unsubscribe();
    this.roListSubs.unsubscribe();
    this.collectorListSubs.unsubscribe();
    this.commissionerListSubs.unsubscribe();

    if (this.masterStatusSub) {
      this.masterStatusSub.unsubscribe();
    }
    if (this.masterSubmitSub) {
      this.masterSubmitSub.unsubscribe();
    }
  }


}
